import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ruTranslation from './locales/ru/translation.json';

// Конфигурация i18next с загрузкой русского словаря из JSON
void i18n.use(initReactI18next).init({
  lng: 'ru',
  fallbackLng: 'ru',
  debug: false,
  interpolation: { escapeValue: false },
  resources: {
    ru: { translation: ruTranslation },
  },
});

export default i18n;
